import React, { useState, useEffect } from 'react'
import styles from './styles'
import { appSumoSignUpAction } from '../../reducers/sign-up/action.js'
import translator from '../../translate'
import parse from 'html-react-parser'
import moment from 'moment-timezone'
import FavoriteIcon from '@material-ui/icons/Favorite'
import { useDispatch } from 'react-redux'
import { snackbarDispose } from '../../reducers/snackbar/action.js'
import { withSnackbar } from 'notistack'
import { connect } from 'react-redux'
import Preloader from '../../components/preloader'

// material
import {
  Container,
  CssBaseline,
  Paper,
  Typography,
  FormControlLabel,
  Checkbox,
  Grid,
  Box,
  InputAdornment,
  withStyles,
} from '@material-ui/core'

import {
  CoreButton,
  CoreFormLayout,
  CoreIconButton,
  CoreTextField,
} from 'src/components/core'
import { Icon } from '@iconify/react'
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

function AppSumoSignUp(props) {
  const dispatch = useDispatch()
  const { classes, snackbar, enqueueSnackbar, process } = props
  const [showPassword, setShowPassword] = useState(false)
  const [promoCodes, setPromoCodes] = useState('')
  const [signupEmail, setSignupEmail] = useState('')
  const [password, setPassword] = useState('')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [brandName, setBrandName] = useState('')
  const [receivesEmail, setReceivesEmail] = useState(false)
  const [termsOfService, setTermsOfService] = useState(false)
  const [privacyPolicy, setPrivacyPolicy] = useState(false)

  useEffect(() => {
    if (snackbar.messages) {
      snackbar.messages.forEach(message => {
        message.messageIds.forEach(messageId => {
          enqueueSnackbar(translator._(messageId), {
            preventDuplicate: true,
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'center',
            },
          })
        })
        dispatch(snackbarDispose(message.id))
      })
    }
  }, [snackbar, enqueueSnackbar, dispatch])
  const handleSubmit = () => {
    const timeZone = moment.tz.guess()

    const data = {
      email: signupEmail.trim(),
      name: firstName,
      surName: lastName,
      shopName: brandName,
      password: password,
      receivesEmail: receivesEmail,
      timeZone,
      promoCodes: promoCodes.split(',').map(x => (x = x.trim())),
    }
    dispatch(appSumoSignUpAction(data))
  }

  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      {process && <Preloader process={process} />}
      <Grid item xs={false} sm={4} md={7} className={classes.image}></Grid>
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <div className={classes.appSumo}>
            <Container className={classes.appSumo}>
              <img src="/assets/logo.png" height="40" alt="logo" />
              <Box m={1}></Box>
              <FavoriteIcon color="primary"> </FavoriteIcon>
              <Box m={1}></Box>
              <img
                src="/assets/as-appsumo-logo-blk.png"
                height="24"
                width="150"
                alt="logo"
              />
            </Container>
          </div>
          <Box m={2}></Box>
          <Typography component="h1" variant="h5">
            {translator._('signUp.sumoLings')}
          </Typography>
          <Box m={2}></Box>

          <div className={classes.form}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
              }}
            >
              <CoreFormLayout
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                width="100%"
                itemsPerRow={1}
                itemGap="16px"
              >
                <CoreTextField
                  required
                  fullWidth
                  label={translator._('signUp.appSumoCode')}
                  placeholder="Code1, Code2, Code3"
                  onBlur={e => setPromoCodes(e.target.value)}
                />

                <CoreTextField
                  required
                  fullWidth
                  id="email"
                  name="email-no-autofill"
                  label={translator._('signUp.email')}
                  onBlur={e => setSignupEmail(e.target.value)}
                  autoComplete="off"
                  inputProps={{
                    autoComplete: 'new-password',
                    form: {
                      autoComplete: 'off',
                    },
                  }}
                />

                <CoreTextField
                  required
                  fullWidth
                  name="password-no-autofill"
                  label={translator._('signUp.password')}
                  type={showPassword ? 'text' : 'password'}
                  onBlur={e => setPassword(e.target.value)}
                  autoComplete="new-password"
                  InputProps={{
                    autoComplete: 'new-password',
                    endAdornment: (
                      <InputAdornment position="end">
                        <CoreIconButton
                          color="dark"
                          variant="text"
                          size="small"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? (
                            <Icon icon="mdi:eye" />
                          ) : (
                            <Icon icon="mdi:eye-off" />
                          )}
                        </CoreIconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </CoreFormLayout>
              <CoreFormLayout
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
                width="100%"
                itemsPerRow={2}
                itemGap="16px"
              >
                <CoreTextField
                  autoComplete="fname"
                  required
                  fullWidth
                  label={translator._('signUp.firstName')}
                  onBlur={e => setFirstName(e.target.value)}
                />

                <CoreTextField
                  required
                  fullWidth
                  id="surName"
                  label={translator._('signUp.lastName')}
                  name="surName"
                  onBlur={e => setLastName(e.target.value)}
                />
              </CoreFormLayout>
              <CoreTextField
                required
                fullWidth
                id="shopName"
                label={translator._('signUp.companyName')}
                name="shopName"
                onBlur={e => setBrandName(e.target.value)}
              />

              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    name="ReceivesEmail"
                    id="ReceivesEmail"
                    onChange={() => setReceivesEmail(!receivesEmail)}
                    checked={receivesEmail}
                  />
                }
                label={translator._('signUp.iWantToReceiveMarketing')}
              />

              <FormControlLabel
                control={
                  <Checkbox
                    value={termsOfService}
                    color="primary"
                    name="ReceivesEmail"
                    id="ReceivesEmail"
                    onChange={() => {
                      setTermsOfService(!termsOfService)
                    }}
                    checked={termsOfService}
                  />
                }
                label={parse(translator._('signUp.termsOfUse'))}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    value={privacyPolicy}
                    color="primary"
                    name="ReceivesEmail"
                    id="ReceivesEmail"
                    onChange={() => {
                      setPrivacyPolicy(!privacyPolicy)
                    }}
                    checked={privacyPolicy}
                  />
                }
                label={parse(translator._('signUp.privacyPolicy'))}
              />
            </div>
            <CoreButton
              fullWidth
              size="large"
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={() => handleSubmit()}
              disabled={
                signupEmail == '' ||
                password == '' ||
                firstName == '' ||
                lastName == '' ||
                brandName == '' ||
                privacyPolicy == false ||
                termsOfService == false ||
                promoCodes == ''
                  ? true
                  : false
              }
            >
              {translator._('signUp.signUp')}
            </CoreButton>
            <Grid container justifyContent="flex-end">
              <Grid item></Grid>
            </Grid>
          </div>
        </div>
      </Grid>
    </Grid>
  )
}
const mapStateToProps = response => ({
  snackbar: response.snackbar,
  process: response.process,
})
export default connect(mapStateToProps)(
  withStyles(styles)(withSnackbar(AppSumoSignUp)),
)
